import { render, staticRenderFns } from "./CurrentStatus.vue?vue&type=template&id=6c83bf87&scoped=true&"
import script from "./CurrentStatus.vue?vue&type=script&lang=js&"
export * from "./CurrentStatus.vue?vue&type=script&lang=js&"
import style0 from "./CurrentStatus.vue?vue&type=style&index=0&id=6c83bf87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c83bf87",
  null
  
)

export default component.exports